// extracted by mini-css-extract-plugin
export default {"link":"rCWdyw","root":"XDYQqS","bg":"X_Xc1y","label":"PyJijQ","top":"LPr5s6","bottom":"fSFv_X"};